// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Buah","col":"CardReaderDesc_col__2nhKO","label":"CardReaderDesc_label__24L_Q"};